<template>
  <div v-if="inputNews" class="daily-video">
    <div class="title d-flex justify-content-between">
      <div style="text-align:left;width:68%" class="pt-2">
        <h2>{{inputNews.name}}</h2>
        <h5>{{inputNews.name_en}}</h5>
      </div>
      <div class="d-flex" style="text-align: right;">
        <!-- <span class="pointer p-2" v-if="!inputNews.is_favorite" @click="addCollections(newsData)" ><img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_mark_off.png" alt="">
          <span class="rwd-hide">
            {{ $t('Home.Keep') }}
          </span>
        </span>
        <span class="pointer p-2" v-else @click="removeCollections()" ><img  src="../assets/image/pic/btn_function_mark_on.png"  alt="">
          <span class="rwd-hide">
            {{ $t('Home.Keep') }}
          </span>
        </span> -->
          <span class="pointer p-2" @click="goMore()"><img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
            <span class="rwd-hide">{{ $t('Home.watch_more') }}</span>
          </span>
      </div>
    </div>
    <div class="d-md-flex align-items-stretch">
      <div @click="goPage()" class="picture pointer image-box daily-box rwd-box pr-3">
        <img class="cover" style="width:100%;" v-if="inputNews && newsData && newsData.cover" :src="inputNews.cover" alt="">
        <div v-if="levelLabels.length" class="image-level-list">
          <span v-for="level in levelLabels" :key="level" class="image-level-badge">{{ level }}</span>
        </div>
      </div>
      <div class="daily-box mt-md-0">
        <div v-if="newsData" class="text-box">
          <p v-for="(item, index) in newsData.modules[0].sentences" :key="index">
            {{item.text}}
          </p>
        </div>
        <div class="btn-box mt-3" style="text-align:right">
          <button type="button" @click="goPage()" class="btn btn-danger">More</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../store/api'
import LivePlayer from 'live-player'
import Player from 'live-player/dist/Player'
import popUp from '@/components/PopUp.vue'
// import LivePlayer2 from '@/views/LivePlayer.vue'
// import libraryApi from '../store/library/api'
export default {
  name: 'DailyNews',
  data () {
    return {
      newsData: null
    }
  },
  props:{
    inputNews: {
      require: false
    },
    view_id: {
      require: false
    },
    fallback_cefr: {
      require: false,
      default: ''
    }
  },
  computed: {
    levelLabels () {
      return this.normalizeCefrLevels(this.inputNews?.cefr || this.fallback_cefr)
    }
  },
  components: {
    popUp,
    Player,
    LivePlayer,
    // LivePlayer2
  },
  mounted () {
    this.getNewsData()
  },
  watch: {
  },
  methods: {
    async getNewsData () {
      const { data } = await api.get(`/contents/lesson/${this.view_id}`)
      if (data.status === 'OK') {
        data.data.modules[0].vocabularies = []
        data.data.modules[0].highlights = []
        this.newsData = data.data
      }
    },
    async addCollections (el) {
      const json = {
        view_id: el.id,
        public_at: this.inputNews.public_at
      }
      try {
        const fileData = new window.FormData()
        fileData.append('json', JSON.stringify(json))
        await api.post(`collections/daily_news/${this.inputNews.id}`, fileData)
        this.$parent.getNews()
      } catch (error) {
        console.error(error.response.data)
      }
    },
    async removeCollections () {
      try {
        await api.delete(`collections/daily_news/${this.inputNews.id}`)
        this.$parent.getNews()
      } catch (error) {
        console.error(error.response.data)
      }
    },
    goPage () {
      this.$router.push({ name: 'CourseLesson', params: { lesson: this.inputNews.id, courseId: this.view_id} })
    },
    goMore (id) {
      this.$router.push({ name: 'News' })
    },
    normalizeCefrLevels (cefr) {
      if (!cefr) {
        return []
      }
      if (Array.isArray(cefr)) {
        return cefr.filter(Boolean).map(level => String(level).trim()).filter(Boolean)
      }
      return String(cefr).split(',').map(level => level.trim()).filter(Boolean)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/custom.scss";
  .daily-box {
    text-align: left;
    width: 100%;
    height: 300px;
    span {
      padding: 0px 10px;
    }
    .text-box {
      height: 85%;
      overflow: auto;
    }
  }
  .picture {
    width: 100%;
    position:relative;
    overflow: hidden;
    margin-right: 20px;
    .cover {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition:all 0.2s ease;
    }
    .tag {
      width: 40px;
      position: absolute;
      padding: 10px
    }
  }
  .image-level-list {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 5;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    max-width: calc(100% - 20px);
    pointer-events: none;
  }
  .image-level-badge {
    min-width: 38px;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: $main-color;
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.4;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  }
  .daily-video {
    h2 {
      font-weight: 800;
      font-size: 1.5rem;
    }
    h5 {
      font-size: 1rem;
    }
  }
  .vocabulary {
    list-style: none;
  }
  @media screen and (max-width: 450px) {
  .daily-box {
    width: 90vw;
  }
  .rwd-box {
    height: 230px !important;
  }
	.info-main {
    margin: 110px 0;
  }
}
</style>
